import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "components/menu";
import config from "./config";

class FoodDiary extends Component {
  render() {
    return <Menu {...config} {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    messages: {
      ...state.intl.messages.containers.features.foodDiary,
      foodCategories:
        state.intl.messages.components.forms.selectOptions.foodCategory,
    },
    foodDiary: state.reducers.foodDiary,
  };
};

export default connect(mapStateToProps)(FoodDiary);
